import React from "react";
import i18n from "@microdoing/shared/i18n";
import {
  Box,
  MainButton,
  MainText,
  PressableOpacity,
} from "app/components/common";
import OnboardingWebInfo from "app/components/common/Onboarding/OnboardingWebInfo";
import OnboardingWebTitle from "app/components/common/Onboarding/OnboardingWebTitle";
import normalize from "app/utils/normalize";

const NoteTalking = require("../../../assets/images/note-talking.png");

interface IProps {
  navigationToSignUp: () => void;
  navigationToAuth: () => void;
}

const WebWelcomeScreen = ({ navigationToSignUp, navigationToAuth }: IProps) => {
  return (
    <Box flex={1} justifyContent="center" backgroundColor="neutral.white">
      <Box variant="webOnboarding" flexDirection="row">
        <OnboardingWebInfo image={NoteTalking} />
        <Box
          flex={1}
          flexDirection="column"
          paddingLeft="webXL"
          paddingTop="webL"
        >
          <Box alignItems="flex-start" justifyContent="center" height="100%">
            <OnboardingWebTitle
              title={i18n.t("web-intro-title")}
              text={i18n.t("web-intro-text")}
            />
            <Box width={normalize(344)}>
              <MainButton
                testID="signup-button"
                onPress={navigationToSignUp}
                text={i18n.t("got-magic-code")}
              />
              <PressableOpacity testID="login" onPress={navigationToAuth}>
                <Box flexDirection="row" marginTop="xs" justifyContent="center">
                  <MainText
                    variant="l3-medium"
                    color="neutral.800"
                    marginRight="xxs"
                  >
                    {i18n.t("got-account")}
                  </MainText>
                  <MainText variant="l3-semibold" color="brand.500">
                    {i18n.t("log-me")}
                  </MainText>
                </Box>
              </PressableOpacity>
            </Box>
          </Box>
        </Box>
      </Box>
    </Box>
  );
};

export default WebWelcomeScreen;
